<template>
  <div
    @click="insertLink"
    class="router-link"
    :class="active_link ? 'nav_active_link' : ''"
  >
    <span v-if="!pres">
      <a
        v-if="(!thisProject && url) || bl"
        :target="bl ? '_blank' : ''"
        :href="url + href"
      >
        <slot></slot>
      </a>

      <router-link v-else :to="href">
        <slot></slot>
      </router-link>
    </span>

    <span v-if="pres">
      <a :target="bl ? '_blank' : ''">
        <slot></slot>
      </a>
    </span>

    <!-- <span v-if="isClickLogin" @click="beforeLoginHandle">
      <slot></slot>
    </span> -->

    <!-- <z-login ref="zLogin" :pathFix="nextBaseUrl"></z-login> -->
  </div>
</template>

<script>
import Cookie from 'js-cookie'
export default {
  name: 'Routing',
  data() {
    return {
      thisProject: false,
      active_link: false,
      linking: '',
    }
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    bl: {
      type: Boolean,
      default: false,
    },
    reversal: {
      type: Boolean,
      default: false,
    },
    // 是否在点击的时候跳转到登录
    isLogin: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: [Object, String],
      default: '',
    },
    pres: {
      type: Boolean,
      default: false,
    },
    // 判定点击钱是否需要验证登录，并弹框
    isClickLogin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 判断登录并且弹框
    // beforeLoginHandle() {
    //   if(Cookie.get('ZHULOGIC_TOKEN')) {
    //     // 直接跳转
    //     window.open(this.url + this.href)
    //   }else {

    //   }
    // },
    insertLink() {
      // 判断是否要提前登录
      if (this.isLogin) {
        if (Cookie.get('ZHULOGIC_STAGE_TOKEN_PRO')) {
          this.activeStyle()
          window.open(this.url + this.href)
        } else {
          // 直接跳转登录页
          window.location.href = this.baseUrl.baseNext + '/sign?redirect=/#nuxt'
        }
      } else {
        this.activeStyle()
      }
    },
    activeStyle() {
      this.active_link = false
      let locationHref = location.href,
        _hrefActive
      if (locationHref.indexOf('/next/') > -1) {
        _hrefActive = window.location.pathname.split('/next/')[1]
      } else if (locationHref.indexOf('/pass/') > -1) {
        _hrefActive = window.location.pathname.split('/pass/')[1]
      } else {
        _hrefActive = window.location.pathname
      }
      this.linking = _hrefActive
      if ('/' + _hrefActive === this.href || _hrefActive === this.href) {
        this.active_link = true
      }
    },
  },
  mounted() {
    let locationHref = window.location.href
    let inNuxt =
      locationHref.indexOf('/pass/') == -1 &&
      locationHref.indexOf('/next/') == -1 &&
      locationHref.indexOf('/mall/') == -1
    if (inNuxt) {
      this.thisProject = this.url === window.location.origin
    } else {
      this.thisProject =
        this.url != window.location.origin &&
        locationHref.indexOf(this.url) != -1
    }
    this.activeStyle()
  },
}
</script>

<style lang="scss">
.zNav-left-item {
  .router-link-active {
    i.icon-zhulogiclogo- {
      color: #313131 !important;
    }
    button {
      span {
        position: relative;
        z-index: 1;
      }
      span::after {
        content: '';
        width: 100%;
        display: block;
        height: 3px;
        background: #ff8e61;
        position: absolute;
        top: 15px;
        left: 0px;
        z-index: -1;
      }
    }
  }
  .nav_active_link {
    .nothing-aftter {
      span::after {
        width: 0px;
        height: 0px;
      }
    }
  }
}
.zNav-right-item {
  .router-link-active {
    i {
      color: #ec6464 !important;
    }
  }
}

.nav-left-item-routing {
  .router-link-active {
    button {
      span::after {
        width: 0px !important;
      }
    }
  }

  button:hover {
    span {
      position: relative;
    }
    span::after {
      content: '';
      width: 100% !important;
      display: block;
      height: 3px !important;
      background: #ff8e61 !important;
      position: absolute;
      top: 15px;
      left: 0px;
    }
  }

  .nuxt-link-exact-active {
    button {
      span {
        position: relative;
      }
      span::after {
        content: '' !important;
        width: 100% !important;
        display: block !important;
        height: 3px !important;
        background: #ff8e61 !important;
        position: absolute;
        top: 15px;
        left: 0px;
      }
    }
  }
}
</style>
